import { execa } from 'execa'
import prompts from 'prompts'
import ora from 'ora'
import path from 'path'
import fs from 'fs-extra'

import { logger } from '@/src/utils/logger'
import { getPackageManager } from '@/src/utils/get-package-manager'

export async function createProject(cwd: string) {
  const packageManager = await getPackageManager(cwd)

  const { name } = await prompts({
    type: 'text',
    name: 'name',
    message: `What is your project named?`,
    initial: 'v0-app',
    format: (value: string) => value.trim(),
    validate: (value: string) =>
      value.length > 128 ? `Name should be less than 128 characters.` : true,
  })

  const projectPath = `${cwd}/${name}`

  if (fs.existsSync(path.resolve(cwd, name, 'package.json'))) {
    logger.warn(``)
    logger.warn(`A project with the name ${name} already exists.`)
    logger.warn(`Please choose a different name and try again.`)
    logger.warn(``)
    process.exit(1)
  }

  logger.info(``)
  const spinner = ora(`Creating a new v0 project...`).start()

  // Note: pnpm fails here. Fallback to npx with --use-PACKAGE-MANAGER.
  const args = [
    '--tailwind',
    '--eslint',
    '--typescript',
    '--app',
    '--no-src-dir',
    '--no-import-alias',
    `--use-${packageManager}`,
  ]
  await execa('npx', ['create-next-app', projectPath, '--silent', ...args], {
    cwd,
  })
  spinner.succeed()

  return {
    projectPath,
    projectName: name,
  }
}
